<template>
  <span>
    <b-button
      v-if="!isIcon && PMC_JOBID"
      class="mb-1 mt-1"
      @click="showModal()"
      size="sm"
      style="font-size: 0.675rem"
      variant="outline-primary"
      >Timeline</b-button
    >
    <b-button v-else-if="isIcon && PMC_JOBID"
        @click="showModal()" 
        size="sm" 
        variant="outline-dark" 
        class="mr-1 btn-action"
        v-b-tooltip.hover title="Timeline"
    >
        <i :class="iconClass || 'fa fa-clock-o'"></i>
    </b-button>
  <b-modal
    id="timeline-modal"
    ref="timelineModal"
    title="Assignment Timeline Details"
    size="xl"
    hide-footer
    @show="fetchTimeline"
    @hidden="resetData"
  >
    <div class="row mb-3">
      <div class="col-md-6">
        <b-form-input
          v-model="search"
          placeholder="Search logs by message..."
          @keyup.enter="fetchTimeline(1)"
        ></b-form-input>
      </div>
      <div class="col-md-6 text-right">
        <b-button variant="primary" @click="fetchTimeline(1)">
          <i class="align-middle" data-feather="search"></i> Search
        </b-button>
        <b-button variant="success" class="ml-2" @click="exportToExcel">
          <i class="fa fa-file-excel-o"></i> Export to Excel
        </b-button>
      </div>
    </div>

    <!-- Table -->
    <b-table
      hover
      striped
      responsive
      show-empty
      :items="timelineData"
      :fields="fields"
      :busy="isBusy"
    >
      <template slot="cell(MessageDate)" slot-scope="data">
        {{ formatIST(data.item.MessageDate) }}
      </template>
      
      <template slot="table-busy">
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
    </b-table>

    <!-- Pagination -->
    <div class="d-flex justify-content-between align-items-center" v-if="totalRows > 0">
      <div>
        Showing {{ (currentPage - 1) * perPage + 1 }} to
        {{ Math.min(currentPage * perPage, totalRows) }} of {{ totalRows }} entries
      </div>
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        @input="handlePageChange"
        class="mb-0"
      ></b-pagination>
    </div>
  </b-modal>
  </span>
</template>

<script>
import LogManagementService from "../../services/LogManagementService";
import ExcelExportService from "../../services/ExcelExportService";
import moment from "moment";

export default {
  name: "TimelineModal",
  
  props: {
    PMC_title: { type: String, default: "" },
    PMC_JOBID: { type: [String, Number], default: "" },
    PMC_JOBNO: { type: String, default: "" },
    PMC_JOBDATE: { type: String, default: "" },
    PMC_JOBTYPE: { type: String, default: "" },
    PMC_Client: { type: String, default: "" },
    PMC_Sline: { type: String, default: "" },
    isIcon: { type: Boolean, default: false },
    iconClass: { type: String, default: '' },
  },
  data() {
    return {
      allModuleId: this.PMC_JOBID,
      Page_title: this.PMC_title,
      timelineData: [],
      isBusy: false,
      search: "",
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      fields: [
        { key: "Message", label: "Log Message", sortable: false },
        { key: "MessageCreatedBy", label: "Created By", sortable: false },
        { key: "MessageDate", label: "Date", sortable: false },
        { key: "ShipmentType", label: "Shipment Type", sortable: false },
        { key: "PrealertStatus", label: "Prealert Status", sortable: false },
        { key: "PrealertDate", label: "Prealert Date", sortable: false },
        { key: "ManifestStatus", label: "Manifest Status", sortable: false },
        { key: "ManifestDate", label: "Manifest Date", sortable: false },
      ],
    };
  },
  watch: {
   
    PMC_JOBID: {
      handler: function (newVal, oldVal) {
        this.allModuleId = newVal;
      },
      deep: true,
    },
    PMC_title(newVal) {
      this.Page_title = newVal;
    }
  },
  methods: {
    showModal() {
      if (!this.allModuleId) {
        console.log("Invalid module ID for timeline.", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
        return;
      }
      this.$refs.timelineModal.show();
    },
    hideModal() {
      this.$refs.timelineModal.hide();
    },
    resetData() {
      this.search = "";
      this.currentPage = 1;
      this.timelineData = [];
      this.totalRows = 0;
    },
    fetchTimeline(page = 1) {
      if (!this.allModuleId) return;
      this.isBusy = true;
      this.currentPage = this.currentPage || 1;

      const payload = {
        pageNo: this.currentPage,
        pageSize: this.perPage,
        search_txt: this.search,
        isSelectedColumn:0,
        Filters: {
          allModuleId: this.allModuleId,
        },
      };

      LogManagementService.getTimelineLog(payload)
        .then((response) => {
          console.log("Timeline response", response);
          const records = response && response.data && response.data.data && Array.isArray(response.data.data.data)
            ? response.data.data.data
            : [];
          this.timelineData = records;
          const pagination = response && response.data && response.data.data && response.data.data.pagination
            ? response.data.data.pagination
            : {};
          this.totalRows = pagination.count || records.length || 0;
        })
        .catch((error) => {
          console.error("Error fetching timeline logs:", error);
          this.timelineData = [];
          this.totalRows = 0;
        })
        .finally(() => {
          this.isBusy = false;
        });
    },
    formatIST(dateString) {
      if (!dateString) return "";
      // Assumes dateString is in UTC or parsable by moment
      return moment.utc(dateString).utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss");
    },
    handlePageChange(page) {
      this.fetchTimeline(page);
    },
    exportToExcel() {
      if (!this.allModuleId) return;

      const payload = {
        pageNo: 1,
        pageSize: 10,
        search_txt: this.search,
        Filters: {
          allModuleId: this.allModuleId,
        },
      };

      // notify user about start of export
      console.log("Export started, please wait...", {
        title: "Export",
        variant: "info",
        solid: true,
      });

      ExcelExportService.exportWithService(LogManagementService, "getTimelineLog", payload)
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          a.download = `Timeline_Export_${this.allModuleId}.xlsx`;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        })
        .catch((error) => {
          console.error("Export error", error);
          console.log("Excel export failed.", {
            title: "Error",
            variant: "danger",
            solid: true,
          });
        });
    },
  },
};
</script>

<style scoped>
/* Add any custom styles here */
</style>



// WEBPACK FOOTER //
// TimelineModal.vue?7cfbe862